import { setBcUpdateMethod } from '~/themes/novaporta/utils/cart'

export default {
    data() {
        return {
            tabId: null,
            bc: null,
        }
    },
    methods: {
        subscribeForProductsCartUpdate(fetchMethod) {
            this.bc = new BroadcastChannel('product_cart')
            let timeoutId = null
            let lastQueuedEvent = null
                
            this.bc.onmessage = (event) => {
                const targetTabId = event.data.tabId
        
                if (targetTabId === this.tabId) return
                lastQueuedEvent = event
                if (timeoutId) clearTimeout(timeoutId)
        
                // Set a new timeout for 1 seconds
                timeoutId = setTimeout(() => {
                    if (lastQueuedEvent) {
                        // Execute the fetch method using the last queued event
                        fetchMethod()
                        lastQueuedEvent = null // Clear the queue after execution
                    }
                }, 1000)
            };
        },
        bcCartUpdatePostMessage() {
            const bc = new BroadcastChannel('product_cart')
                
            bc.postMessage({
                tabId: this.tabId
            })

            bc.close()
        },
        createTabId() {
            this.tabId = Date.now()
        }
    },
    mounted() {
        setBcUpdateMethod(this.bcCartUpdatePostMessage)
        this.createTabId()
    },
    beforeDestroy() {
        if (this.bc) this.bc.close()
    }
}
